export default __webpack_public_path__ + "static/media/defaultImage.a5f12abf.jpg";